import Axios from "axios";
import {
  SET_LC_INCOTERM_LIST,
  UNSET_LC_INCOTERM_LIST,
} from "@/store/mutation-types";
import { saveUpdateLcIncoterm, getLcIncotermList } from "@/store/api";

const state = {
  lcIncotermList: [],
};

const getters = {
  getLcIncotermList(state) {
    return state.lcIncotermList;
  },
};

const mutations = {
  [SET_LC_INCOTERM_LIST](state, data) {
    state.lcIncotermList = data;
  },
  [UNSET_LC_INCOTERM_LIST](state) {
    state.lcIncotermList = [];
  },
};

const actions = {
  saveUpdateLcIncoterm({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcIncoterm, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcIncotermList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcIncotermList, data)
        .then(function (response) {
          commit("SET_LC_INCOTERM_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_INCOTERM_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

